import React, { forwardRef, useImperativeHandle } from "react";

export const CustomTooltip = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => {
    return {
      getReactContainerClasses() {
        return ["custom-tooltip"];
      },
    };
  });

  return (
    <div className="custom-tooltip">
      <p>{props.value}</p>
    </div>
  );
});

export default CustomTooltip;
